import { Component } from '@angular/core'

@Component({
  selector: 'app-not-found',
  imports: [],
  templateUrl: './not-found.html',
  styleUrl: './not-found.sass',
})
export class NotFound {}
